import {Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HhsgSharedConfigService} from "./config.service";

@Injectable({
  providedIn: 'root',
})
export class XsrfService {
  constructor(private _httpClient: HttpClient, private _configService: HhsgSharedConfigService) { }

  public initXsrf() : Observable<any> {
    let url = `${this._configService.appSettings.webApiServer}/api/Xsrf/InitXsrf`;
    return this._httpClient.head<any>(url,  { withCredentials: true });
  }
}
